import React, { useState, useCallback, useEffect } from 'react'
import NeoButton from '../../../components/NeoButton/NeoButton'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import PaymentsService from '../../../services/payments.service'
import Modal from '../../../components/Modal/Modal'
import { useModal } from 'react-modal-hook'
import LayoutWithOutAccountCard from '../../../layout/Layout/layout-without-card'
import NeoLoader from '../../../components/FormComponents/NeoLoader'
import {
  DIALOG_KEYS,
  VALIDATION_MESSAGES,
  DEPOSITS_KEYS,
  SIDENAV_KEYS,
  PAYMENT_KEYS,
} from '../../../utils/translation-constants'

const SERVICE_LABELS = {
  Topstar: 'Meter No.',
  Airtel_Topup: 'Mobile No.',
  Zamtel_Topup: 'Mobile No.',
  MTN_Topup: 'Mobile No.',
  Zesco: 'Meter No.',
  GOtv: 'IUC No.',
  DStv: 'Smart Card No.',
  LiquidTelecom_Data: 'Account No.',
  MTN_Data: 'Account No.',
  Vodafone: 'Account No.',
  MLife: 'Account No.',
  Afribus: 'Service No.',
  ZRA: 'PRN',
}

export default function BillerBeneList() {
  const history = useHistory()
  const [noRecords, setNoRecords] = useState(false)
  const [billerBeneList, setBillerBeneList] = useState([])
  const [loading, setLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const { t } = useTranslation()
  const [stage, setStage] = useState(0)
  const [message, setMessage] = useState('')
  const [selectedBiller, setSelectedBiller] = useState({})

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <h6>{message}</h6>
        <div className='mt-4 col-6 mx-auto'>
          <NeoButton type='button' mode='newDesign' text={t(DIALOG_KEYS.OK)} onClick={hideModal} />
        </div>
      </Modal>
    ),
    [message],
  )

  const [showDeleteBeneModal, hideDeleteBeneModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{t(PAYMENT_KEYS.QUESTION_DELETE)}</h6>
          <div className='row' style={{ marginTop: 30 }}>
            <div className='form-group col-6'>
              {deleteLoading ? (
                <NeoLoader />
              ) : (
                <NeoButton
                  type='button'
                  text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CONFIRM_BUTTON)}
                  mode='newDesign'
                  onClick={() => deleteBillerBeneficiary()}
                />
              )}
            </div>
            <div className='form-group col-6' style={{ display: 'flex' }}>
              <div
                className='back-cancel-style'
                style={{ marginTop: 15 }}
                onClick={() => hideDeleteBeneModal()}>
                {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    ),
    [deleteLoading, selectedBiller],
  )

  const deleteBillerBeneficiary = useCallback(async () => {
    try {
      setDeleteLoading(true)
      const response = await PaymentsService.deleteBillerBene({
        beneId: selectedBiller?.beneId,
        serviceId: selectedBiller?.serviceId,
      })
      if (response.status === 200) {
        setDeleteLoading(false)
        hideDeleteBeneModal()
        setBillerBeneList([])
        setMessage(response.data['message'])
        showModal()
        fetchBillerBeneficiaries()
      }
    } catch (err) {
      hideDeleteBeneModal()
      setDeleteLoading(false)
    }
  }, [selectedBiller])

  const handleDeleteBene = useCallback(async (selected) => {
    await setSelectedBiller(selected)
    showDeleteBeneModal()
  }, [])

  const fetchBillerBeneficiaries = useCallback(async () => {
    try {
      setLoading(true)
      const response = await PaymentsService.getAllBillerBeneficiaries()
      if (response.status === 200) {
        response.data['billerBeneficiary'].forEach((element) => {
          element.isActive = false
        })
        setBillerBeneList(response.data['billerBeneficiary'])
        setNoRecords(response.data['billerBeneficiary'].length === 0 ? true : false)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])
  useEffect(() => {
    fetchBillerBeneficiaries()
  }, [])

  return (
    <LayoutWithOutAccountCard
      breadCumKey='VIEW_BILLER'
      showEmptySpace={true}
      keyPath={'VIEW_BILLER'}>
      <div className='row'>
        <div className='col-7 d-flex'>
          <div className='heading-style'>{t(PAYMENT_KEYS.VIEW_BILLER)}</div>
        </div>
      </div>

      {loading && <NeoLoader />}

      <div className='row'>
        {billerBeneList.map((option, i) => (
          <div key={i} className='col-6'>
          <div className='deposit-menu-card deposit-menu-card-details deposit-menu-card-biller'>
            <div >
              <div className='deposit-header col-12 p-0'>
                <label className="col-5 p-0">{t(PAYMENT_KEYS.SHORT_NAME1)}</label>
                <p className='col-8 p-0'>{option?.shortName || '-'}</p>
              </div>
              <div className='deposit-header col-12 p-0'>
                <label className="col-5 p-0">{t(PAYMENT_KEYS.MERCHANT)}</label>
                <p className='col-8 p-0'>{option?.merchant || '-'}</p>
              </div>
              <div className='deposit-header col-12 p-0'>
                <label className="col-5 p-0">{`${option?.merchant} No.`}</label>
                <p className='col-8 p-0'>{option?.serviceNumber || '-'}</p>
              </div>
            </div>
            <div>
              <div className='back-cancel-style' onClick={() => handleDeleteBene(option)}>
                {' '}
                {t(PAYMENT_KEYS.DELETE)}
              </div>
            </div>
          </div>
        </div>
        ))}
      </div>

      {noRecords && <div className='no-data-found'>{t(PAYMENT_KEYS.NO_BILLER)} </div>}
    </LayoutWithOutAccountCard>
  )
}
